import { DEFAULT_SEARCH_RESULT_IMAGE_URL } from '../constants';
import { ArticleSearchObject, ArticleSearchResult } from './types';

export const convertSearchObjectToSearchResult = ({
  id,
  url,
  title,
  description,
  image,
  label,
  categories,
}: ArticleSearchObject): ArticleSearchResult => {
  let parsedImage: ArticleSearchResult['image'] | undefined;

  if (image) {
    try {
      const imageArray = JSON.parse(image);
      const firstImage = Array.isArray(imageArray) ? imageArray[0] : imageArray;

      if (firstImage && firstImage.gatsbyImageData) {
        parsedImage = {
          url: firstImage.url || '',
          data: {
            gatsbyImageData: firstImage.gatsbyImageData,
          },
        };
      }
    } catch {
      // If parsing fails, use default image
      parsedImage = {
        url: DEFAULT_SEARCH_RESULT_IMAGE_URL,
        data: null,
      };
    }
  }

  return {
    id,
    url,
    title,
    description,
    categories,
    label,
    image: parsedImage,
  };
};
